import React from "react";
import { Users } from "lucide-react";
import MyImage from '../assets/Image/about.png'

const About = () => (
  <section
    id="about"
    className="py-16 md:py-24 bg-gradient-to-b from-gray-50 to-white flex flex-col lg:flex-row items-center justify-center max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 gap-12 lg:gap-16"
  >
    <div className="lg:w-1/2 flex justify-center">
      <div className="relative w-full max-w-md lg:max-w-lg overflow-hidden rounded-2xl transition-transform duration-500 ease-in-out hover:scale-[1.02]">
        <img
          src={MyImage}
          alt="Pixel Prime Team"
          className="w-full h-auto object-cover"
          loading="lazy"
        />
      </div>
    </div>
    <div className="lg:w-1/2 text-center lg:text-left space-y-6">
      <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 tracking-tight">
        About Us
      </h2>
      <div className="flex justify-center lg:justify-start pb-4 mb-6 border-b border-gray-200">
        <Users size={48} className="text-indigo-600 transition-transform duration-300 ease-in-out hover:scale-110" />
      </div>
      <p className="text-gray-700 max-w-2xl mx-auto lg:mx-0 text-base sm:text-lg leading-relaxed transition-opacity duration-300 ease-in-out hover:opacity-90">
        At{" "}
        <span className="font-semibold text-indigo-600">Pixel Prime</span>, we’re a dynamic team of developers and designers committed to empowering businesses with a vibrant online presence.
      </p>
      <p className="text-gray-600 max-w-2xl mx-auto lg:mx-0 text-base sm:text-lg leading-relaxed">
        From startups to personal brands, we create{" "}
        <strong className="text-indigo-600">modern, responsive,</strong> and{" "}
        <strong className="text-indigo-600">user-centric</strong> websites that captivate and deliver results.
      </p>
      <div className="mt-8">
        <a
          href="#contact"
          className="inline-block px-6 py-3 bg-indigo-600 text-white font-semibold rounded-lg shadow-md hover:bg-indigo-700 transition-colors duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
        >
          Get in Touch
        </a>
      </div>
    </div>
  </section>
);

export default About;